import axios from "axios";
import ModalManager from "../../components/common/modal/ModalManager";
import NotificationManager from "../../utils/notificationManager";
import OutletGroupSelector from "./OutletGroupSelector";

const modalOptions = {
  preventOutsideClose: true,
  modalStyle: {
    minWidth: "540px",
    width: "680px",
    maxWidth: "95vw",
  },
  contentStyle: {
    maxHeight: "70vh",
    overflowY: "auto",
  },
};

export default function openOutletGroupModal({
  outlet,
  groups = [],
  refreshGroups,
}) {
  const outletGroups = groups.filter(g => g.groupType === "outlets");
  const outletIdStr = String(outlet.outlet_id);
  const initialSelection = outletGroups
    .filter(
      group =>
        Array.isArray(group.items) &&
        group.items.some(item => String(item) === outletIdStr)
    )
    .map(group => String(group.id));

  const handleSave = async selectedIds => {
    const selectedSet = new Set(selectedIds.map(id => String(id)));
    const currentSet = new Set(initialSelection);

    const toAdd = [...selectedSet].filter(id => !currentSet.has(id));
    const toRemove = [...currentSet].filter(id => !selectedSet.has(id));
    if (!toAdd.length && !toRemove.length) return;

    const headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };

    try {
      await Promise.all([
        ...toAdd.map(groupId =>
          axios.post(
            `/v1/groups/${groupId}/addOutlet`,
            { outletIds: [outlet.outlet_id] },
            { headers }
          )
        ),
        ...toRemove.map(groupId =>
          axios.post(
            `/v1/groups/${groupId}/removeOutlet`,
            { outletIds: [outlet.outlet_id] },
            { headers }
          )
        ),
      ]);

      NotificationManager.success("Outlet groups updated");
      await refreshGroups?.();
    } catch (error) {
      console.error(error);
      NotificationManager.alert("Unable to update outlet groups right now.");
      throw error;
    }
  };

  ModalManager.confirm(
    "",
    "Manage Outlet Groups",
    "",
    () => {},
    ({ close }) => (
      <OutletGroupSelector
        outlet={outlet}
        groups={groups}
        initialSelection={initialSelection}
        onSave={handleSave}
        close={close}
      />
    ),
    true,
    true,
    modalOptions
  );
}
